;(function () {
  'use strict'
  angular
    .module('contrast.onboarding.setup')
    .factory(
      'onboardingSetupApiConfig',
      function onboardingSetupApiConfigFactory($http, UserService) {
        'ngInject'

        return {
          getSteps: getSteps
        }

        function getSteps() {
          return $http.get(UserService.buildAPIUrl('/onboarding/setup'))
        }
      }
    )
})()
